<template>
    <div>
        <b-input-group class="filter-group">
            <b-input-group-prepend is-text>
                <font-awesome-icon icon="search" />
            </b-input-group-prepend>
            <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
            <b-input-group-append>
                <b-button @click="filter = ''">Clear</b-button>
            </b-input-group-append>
        </b-input-group>

        <b-card-group deck>
            <b-card :title="item.title" header-tag="header" v-for="item in filteredItems" :key="item.id" :item="item" class="mb-2" style="max-width: 20rem;min-width: 20rem;">
                <!-- <h6 slot="header"
                    class="mb-0">{{ item.title }}</h6> -->
                <p class="card-text" v-html="getDecodedHtml(item.preview)"></p>
                <router-link :to="{ name: 'contentDetails', params: { id: item.id, name: item.name } }">
                  <b-button variant="primary">View More</b-button>
                </router-link>
            </b-card>
        </b-card-group>
    </div>
</template>
<script>
import { mapState } from "vuex";
var htmlDecode = require("js-htmlencode").htmlDecode;

export default {
  data() {
    return {
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      filter: ""
    };
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    filteredItems: function() {
      var that = this;
      return this.content.filter(item => {
        return (
          item.title.toLowerCase().indexOf(that.filter.toLowerCase()) > -1 ||
          item.description.toLowerCase().indexOf(that.filter.toLowerCase()) > -1
        );
      });
    }
  },

  methods: {
    getDecodedHtml(encodedString) {
      if (encodedString) {
        return htmlDecode(encodedString);
      }
      return "";
    }
  },

  props: {
    content: {
      type: Array,
      required: true
    }
  },

  created() {}
};
</script>
<style scoped>
.filter-group {
  margin: 10px 0 15px 0;
  max-width: 600px;
}

.student-search {
  max-width: 500px;
}
.container {
  max-width: 100%;
}

.filter-input {
  width: 300px;
  max-width: 80%;
  flex: none !important;
}

.filter-group {
  margin: 10px 0 10px 0;
}

.form-control {
  display: inline-block;
  width: 300px !important;
}

.new-incident-btn {
  float: right;
}
</style>
